import {
 createStore, combineReducers, applyMiddleware, compose,
} from 'redux';
import createSagaMiddleware from 'redux-saga';
import { all, spawn, put } from 'redux-saga/effects';
import { persistStore, persistReducer } from 'redux-persist';
import localForage from 'localforage';
import { whitelist } from './whitelist';

export const initStore = ({ reducers, sagas = {}, modals }, initialState) => {
  const persistConfig = {
    key: `${initialState.city}-${initialState.state}-${initialState.type}`,
    storage: localForage,
    whitelist,
  };
  const sagaMiddleware = createSagaMiddleware();

  const combinedReducers = combineReducers(reducers);
  const persistedReducer = persistReducer(persistConfig, combinedReducers);

  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(
    persistedReducer,
    initialState,
    composeEnhancers(applyMiddleware(sagaMiddleware)),
  );

  function* startAppSagas() {
    try {
      yield all(
        Object.values(sagas).map((saga) => saga({
            modals,
          })),
      );
    } catch (e) {
      console.error(e);
      yield spawn(startAppSagas);
    }
  }

  function* rootSaga() {
    yield spawn(startAppSagas);
    yield put({ type: 'BOOTUP' });
  }

  sagaMiddleware.run(rootSaga);

  window.reduxStore = store;
  const persistor = persistStore(store);

  return { store, persistor };
};
